import moment from "moment";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../shared/topBar/TopBar";
import download from '../../../Images/download.svg';
import { useEffect, useRef, useState } from "react";
import { UrlPath } from "../../../config/routeConfig";
import { getPortfolioAccountListAction, getPortFolioCashAction, getPortFolioCreditFacilityAction, getPortFolioCurrencyAction, getPortFolioDetailAction, getPortFolioDiscretionaryStatusAction, getPortFolioExpenseAction, getPortFolioListAction, getPortFolioManagerAction, getPortFolioTaxStatusAction, getPortFolioTypeAction } from "../../actions/portfolioAction";
import { useDispatch, useSelector } from "react-redux";
import { exportToExcelUsingRef } from "../../utils/excelExporter";
import { deletePortfolioApi, getCustomSettings, getPortfolioAccountsApi, getPortfolioAvailableAsset, getPortfolioDetailAPI, getPortfolioExistingAsset, insertOrUpdatePortfolioAPI, insertPorfolioAccountingAssetAPI } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { Modal } from "react-bootstrap";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { getAssetListByTerm, setActiveMenu } from "../../actions/CommonAction";
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router-dom";


export const NewPortfolio = {
    "PortfolioId": 0,
    "PortfolioName": "",
    "Abbreviation": "",
    "LinkedAssetId": 0,
    "LinkedAssetName": "",
    "Description": "",
    "PortfolioTypeId": 0,
    "PortfolioTypeName": "",
    "DefaultCurrencyId": 0,
    "DefaultCurrencyName": "",
    "DefaultCashId": 0,
    "DefaultCashAccountName": "",
    "DefaultExpenseId": 0,
    "DefaultExpenseAccountName": "",
    "CreditFacilityAccountId": 0,
    "DefaultCreditFacilityAccountName": "",
    "PortfolioManagerId": 0,
    "PortfolioManagerName": "",
    "TaxStatusId": 0,
    "TaxStatusName": "",
    "DiscretionaryStatusId": 0,
    "DiscretionaryStatusName": "",
    "IsQualifiedInvestor": false,
    "IsPartnership": false,
    "BillingExclusion": false,
    "CustodyStatus": false,
    "InternalEmployee": false,
    "CharitableStatus": false,
    "PPLI": false,
    "Notes": "",
    "CloseDate": null,
    "StartDate": "",
    "CreatedBy": 0,
    "CreatedByName": "",
    "TaxEntityId": null,
    "TaxEntityName": "",
    "FamilyId": null,
    "FamilyName": ""
};
export const PortfolioList = () => {
    const dispatch = useDispatch();
    const portfolioRef = useRef();
    const Level = [{ BreadCrumb: "Portfolio", Routes: `/${UrlPath.PortfolioList}` }];
    const Gstate = useSelector(state => state);
    const data = Gstate.portfolio.portfolioList;
    const loading = Gstate.portfolio.isPortfolioLoading;
    const isEditable = Gstate.authorizationData.isEditable;
    const [colDef, setColDef] = useState([]);
    const [appliedFilter, setAppliedFilter] = useState({});
    const [selectedPortFolio, setSelectedPortfolio] = useState(NewPortfolio);
    const [operation, setOperation] = useState(null);
    const [drawer, setDrawer] = useState(false);

    useEffect(() => {
        document.title = "Portfolio";
    }, [isEditable]);
    useEffect(() => {
        dispatch(getPortFolioListAction(null));
        dispatch(getPortFolioDiscretionaryStatusAction());
        dispatch(getPortFolioTaxStatusAction());
        dispatch(getPortFolioManagerAction());
        dispatch(getPortFolioCreditFacilityAction());
        dispatch(getPortFolioExpenseAction());
        dispatch(getPortFolioCashAction());
        dispatch(getPortFolioCurrencyAction());
        dispatch(getPortFolioTypeAction());
    }, []);
    useEffect(() => {
        fetchGridData();
    }, [data]);
    const afterPortfolioSave = () => {
        dispatch(getPortFolioListAction());
    }
    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1016}` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    valueFormatter: ["StartDate", "CloseDate"].includes(item.colId) ? formatIsoToDateString : null,
                    cellRenderer: item.colId === "Action" ? ActionCellRenderer : item.colId === "PortfolioName" ? hyperLinkRender : null,
                    filter: item.colId === "Action" ? false : item.filter,
                    maxWidth: item.colId === "Action" ? 100 : null,
                    minWidth: item.colId === "PortfolioName" ? 700 : 100,
                    headerName:item.colId === "PortfolioTypeName" ? 'Portfolio Type' : null 
                }));
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };
    const formatIsoToDateString = (params) => {
        const value = params.value;
        if (value)
            return moment(value).format("MM-DD-YYYY");
        else
            return "";
    };
    const ActionCellRenderer = (params) => {
        const portfolio = params.data;
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable])
        return (
            <>
                <button style={{ border: "none", height: "0px" }} className="hoverHand" disabled={!isEdit} onClick={() => { handleEdit(portfolio) }}><i className="fas fa-edit" style={{ color: isEditable ? "#47A547" : 'grey', margin: "0 8px" }}></i></button>
                <button style={{ border: "none", height: "0px" }} className="hoverHand" disabled={!isEdit} onClick={() => { handleDelete(portfolio) }}><i className="fas fa-trash" style={{ color: isEditable ? "red" : 'grey', margin: "0 8px" }}></i></button>
            </>

        );
    };
    const hyperLinkRender = (params) => {
        const portfolioName = params.data.PortfolioName;
        const portfolioId = params.data.PortfolioId;
        return <>
            <Link to={`/${UrlPath.PortfolioDetails}${portfolioId}`} onClick={() => { dispatch(setActiveMenu(3)); }} >
                {portfolioName}
            </Link>
        </>
    }
    const handleEdit = (portfolio) => {
        dispatch(getPortFolioDetailAction(portfolio.PortfolioId));
        setDrawer(true);
        setOperation("Update");
    };
    const handleDelete = (portfolio) => {
        setSelectedPortfolio(portfolio);
        setOperation("Delete");
    };
    return <>
        {loading ? <><LoadingScreen /></> : <>
            <TopBar label={"Portfolio"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div>
                        <div className="d-flex justify-content-end gap-2">
                            <button type="submit" className="p-sm-btn mx-1" onClick={() => { setDrawer(true); setSelectedPortfolio(NewPortfolio); setOperation("Add") }} disabled={!isEditable} ><i className="fa-solid fa-plus" /> Add</button>
                            <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(portfolioRef, 'Portfolio List') }}><img src={download} alt="Excel" />Export</button>
                        </div>
                        <SBGrid ref={portfolioRef} column={colDef} filters={appliedFilter} row={data} componentID={1016} gridStyle={{ width: '100%', height: '70vh' }} />
                    </div>
                </div>
            </div>

            <SBADrawer open={drawer} setOpen={setDrawer} title={`${operation} Portfolio`} size='85vw'>
                <PortfolioEditor afterSave={afterPortfolioSave} selectedPortFolio={selectedPortFolio} setDrawer={setDrawer} setSelectedPortfolio={setSelectedPortfolio} operation={operation} />
            </SBADrawer>
            <PortfolioModal portfolio={selectedPortFolio} operation={operation} setOperation={setOperation} />

        </>
        }
        <ToastContainer />
    </>
};
const PortfolioModal = ({ portfolio, operation, setOperation }) => {
    const dispatch = useDispatch();
    const deletePortfolio = () => {
        sbaAxios({ url: `${deletePortfolioApi}${portfolio.PortfolioId},0` }).then(response => {
            setOperation(null);
            if (response === 2) {
                SBNotify({ Msg: "The portfolio cannot be deleted at this time because it is linked to an Account in the system", type: 'error' });
            }
            else {
                SBNotify({ Msg: "Selected Portfolio  has been Successfully Deleted" });
                dispatch(getPortFolioListAction());
            }

        }).catch(error => {
            console.log(error, 'Error Deleting the Portfolio');
            SBNotify({ Msg: "Some Exception Occured, Please Contact Adim", type: "error" });
            setOperation(null);
        })
    }
    return <Modal show={operation === "Delete"}>
        <Modal.Header >
            <Modal.Title>
                {`${operation} Portfolio`}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
                The selected Portfolio ({portfolio.PortfolioName}) will be deleted permanently. Are you sure?
            </p>
        </Modal.Body>
        <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => { setOperation(null) }}>
                Cancel
            </button>
            <button
                className="p-sm-btn mx-1"
                onClick={() => { deletePortfolio() }}
            >
                Delete
            </button>
        </Modal.Footer>
    </Modal>
};









// Portfolio edit section component
export const PortfolioEditor = ({ setDrawer, operation, afterSave }) => {
    const dispatch = useDispatch();
    const [portfolio, setPortfolio] = useState({});
    const [assetList, setAssetList] = useState([]);
    const [initialRender, setInitialRender] = useState(true);
    const [movedInvestment, setMovedInvestment] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    const Gstate = useSelector(state => state);
    const Stateportfolio = Gstate.portfolio.portfolio;
    const portfolioType = Gstate.portfolio.type;
    const currencyList = Gstate.portfolio.currency;
    const creditFacility = Gstate.portfolio.creditFacility;
    const taxStatus = Gstate.portfolio.taxStatus;
    const managers = Gstate.portfolio.manager;
    const cash = Gstate.portfolio.cash;
    const expense = Gstate.portfolio.expense;
    const assetListByText = Gstate.common.assetListSearched;
    const taxEntityList = Gstate.portfolio.portfolioAccount || [];

    useEffect(() => { setIsEdit(isEditable) }, [isEditable])

    useEffect(() => {
        if (operation === "Add")
            setPortfolio(NewPortfolio);
        else
            setPortfolio(Stateportfolio);
    }, [Stateportfolio]);
    useEffect(() => {
        if (initialRender) {
            setInitialRender(false);
            return;
        }
        else {
            setAssetList(assetListByText || []);
        }

    }, [assetListByText]);
    useEffect(() => {
        if (initialRender) {
            setInitialRender(false);
            return;
        }
        else {
            setAccountList(taxEntityList || []);
        }

    }, [taxEntityList]);


    const insertOrUpdatePortfolio = () => {
        if (isEdit) {
            let isInvestmentAdded = true;
            if (operation === "Add" && movedInvestment.length === 0) {
                isInvestmentAdded = false;
            }
            const newData = {
                "portfolioId": portfolio.PortfolioId || 0,
                "portfolioName": portfolio.PortfolioName || "",
                "taxEntityId": portfolio.TaxEntityId || null,
                "abbreviation": portfolio.Abbreviation || "",
                "linkedAssetId": portfolio.LinkedAssetId || 0,
                "description": portfolio.Description || "",
                "portfolioTypeId": portfolio.PortfolioTypeId || 0,
                "defaultCurrencyId": portfolio.DefaultCurrencyId || 0,
                "defaultCashId": portfolio.DefaultCashId || 0,
                "defaultExpenseId": portfolio.DefaultExpenseId || 0,
                "creditFacilityAccountId": portfolio.CreditFacilityAccountId || 0,
                "portfolioManagerId": portfolio.PortfolioManagerId || 0,
                "taxStatusId": portfolio.TaxStatusId || 0,
                "discretionaryStatusId": portfolio.DiscretionaryStatusId || 0,
                "isQualifiedInvestor": portfolio.IsQualifiedInvestor || false,
                "isPartnership": portfolio.IsPartnership || false,
                "billingExclusion": portfolio.BillingExclusion || false,
                "custodyStatus": portfolio.CustodyStatus || false,
                "internalEmployee": portfolio.InternalEmployee || false,
                "charitableStatus": portfolio.CharitableStatus || false,
                "ppli": portfolio.PPLI || false,
                "notes": portfolio.Notes || "",
                "closeDate": portfolio.CloseDate || null,
                "modifiedBy": 0
            };
            if (newData.portfolioName && newData.portfolioTypeId !== 0 && isInvestmentAdded) {
                sbaAxios({ url: insertOrUpdatePortfolioAPI, method: "post", data: newData }).then(response => {
                    if (response === -2) {
                        SBNotify({ Msg: "Portfolio Name Already exist", type: "error" });
                    }
                    else if (operation === "Add") {
                        movedInvestment.map(item => {
                            const data = {
                                "portfolioId": response,
                                "assetId": item.AssetId,
                                "modifiedBy": 0
                            };
                            sbaAxios({ url: insertPorfolioAccountingAssetAPI, method: "post", data: data }).then(response => { }).catch(error => { })
                        });
                        SBNotify({ Msg: "Portfolio has been Successfully Added" });
                        setDrawer(false);
                        afterSave(response);

                    }
                    else {
                        SBNotify({ Msg: "Selected Portfolio has been Successfully Updated" });
                        setDrawer(false);
                        afterSave(response);

                    }

                }).catch((e) => {
                    console.log(e, 'Error Updating')
                });
            }
            else if (!newData.portfolioName || !newData.portfolioTypeId) {
                SBNotify({ Msg: "Please Enter All the mandatory fields", type: "error" });
            }
            else if (!isInvestmentAdded) {
                SBNotify({ Msg: "Please Add Atleast One Accounting Investment", type: "error" });
            }
        }


    };
    const updatePortfolio = (value, key) => {
        setPortfolio(eValue => ({ ...eValue, [key]: value }));
    };
    const updatePortfolioByDD = (IDvalue, NameValue, Id, Name) => {
        setPortfolio(eValue => ({ ...eValue, [Id]: IDvalue, [Name]: NameValue }));
    };
    const getAssetByTerms = (e) => {
        const searchText = e.filter.value;
        if (searchText.length > 1) {
            dispatch(getAssetListByTerm(searchText));
        }
    };
    const getAccountByTerms = (e) => {
        const searchText = e.filter.value;
        if (searchText.length > 1) {
            dispatch(getPortfolioAccountListAction(searchText));
        }
    };
    return <>
        <div className="row mb-4">
            <TextEditor type={"text"} label={"Portfolio Name"} value={portfolio.PortfolioName} setValue={(value) => { updatePortfolio(value, 'PortfolioName') }} colSpan={"col-md-3"} mandatory />
            <TextEditor type={"text"} label={"Abbreviation"} value={portfolio.Abbreviation} setValue={(value) => { updatePortfolio(value, 'Abbreviation') }} colSpan={"col-md-3"} />
            <TextEditor type={"text"} label={"Description"} value={portfolio.Description} setValue={(value) => { updatePortfolio(value, 'Description') }} colSpan={"col-md-3"} />
            <CheckEditor label={"Qualified Investor"} value={portfolio.IsQualifiedInvestor} setValue={(value) => { updatePortfolio(value, 'IsQualifiedInvestor') }} colSpan={"col-md-3"} />
        </div>
        <div className="row mb-4">
            <DropDownEditor label={"Family"} value={{ EnumValue: portfolio.FamilyId, EnumName: portfolio.FamilyName }} setValue={(value) => { if (value) updatePortfolioByDD(value?.EnumValue, value?.EnumName, 'PortfolioTypeId', 'PortfolioTypeName') }} colSpan={"col-md-3"} data={[]} valueField={"EnumValue"} textField={"EnumName"} disabled />
            <DropDownEditor label={"Linked Asset"} value={{ AssetId: portfolio.LinkedAssetId, AssetName: portfolio.LinkedAssetName }} setValue={(value) => { updatePortfolioByDD(value?.AssetId, value?.AssetName, 'LinkedAssetId', 'LinkedAssetName') }} colSpan={"col-md-3"} data={assetList} valueField={"AssetId"} textField={"AssetName"} onFilterChange={getAssetByTerms} placeholder={"Please Enter Asset Name "} />
            <DropDownEditor label={"Linked Account"} value={{ TaxEntityId: portfolio.TaxEntityId, TaxEntityName: portfolio.TaxEntityName }} setValue={(value) => { updatePortfolioByDD(value?.TaxEntityId, value?.TaxEntityName, 'TaxEntityId', 'TaxEntityName') }} colSpan={"col-md-3"} data={accountList} valueField={"TaxEntityId"} textField={"TaxEntityName"} onFilterChange={getAccountByTerms} placeholder={"Please Enter Account Name "} />
            <CheckEditor label={"Custody Status"} value={portfolio.CustodyStatus} setValue={(value) => { updatePortfolio(value, 'CustodyStatus') }} colSpan={"col-md-3"} />
        </div>
        <div className="row mb-4">
            <DropDownEditor label={"Portfolio Type"} value={{ EnumValue: portfolio.PortfolioTypeId, EnumName: portfolio.PortfolioTypeName }} setValue={(value) => { if (value) updatePortfolioByDD(value?.EnumValue, value?.EnumName, 'PortfolioTypeId', 'PortfolioTypeName') }} colSpan={"col-md-3"} data={portfolioType} valueField={"EnumValue"} textField={"EnumName"} mandatory />
            <DropDownEditor label={"Default Currency"} value={{ CurrencyId: portfolio.DefaultCurrencyId, CurrencyName: portfolio.DefaultCurrencyName }} setValue={(value) => { updatePortfolioByDD(value?.CurrencyId, value?.CurrencyName, 'DefaultCurrencyId', 'DefaultCurrencyName') }} colSpan={"col-md-3"} data={currencyList} valueField={"CurrencyId"} textField={"CurrencyName"} />
            <div className={"col-md-3"}>
                <span className="d-block" >
                    Close Date
                </span>
                <SBDatePicker value={moment(portfolio?.CloseDate)} onChange={(e) => { updatePortfolio(e?.toISOString() || null, 'CloseDate') }} />
            </div>
            <CheckEditor label={"Private Placement Life Insurance"} value={portfolio.PPLI} setValue={(value) => { updatePortfolio(value, 'PPLI') }} colSpan={"col-md-3"} />
        </div>
        <div className="row mb-4">
            <DropDownEditor label={"Portfolio Manager"} value={{ UserId: portfolio.PortfolioManagerId, Fullname: portfolio.PortfolioManagerName }} setValue={(value) => { updatePortfolioByDD(value?.UserId, value?.Fullname, 'PortfolioManagerId', "PortfolioManagerName") }} colSpan={"col-md-3"} data={managers} valueField={"UserId"} textField={"Fullname"} />
            <DropDownEditor label={"Tax Status"} value={{ EnumValue: portfolio.TaxStatusId, EnumName: portfolio.TaxStatusName }} setValue={(value) => { updatePortfolioByDD(value?.EnumValue, value?.EnumName, 'TaxStatusId', "TaxStatusName") }} colSpan={"col-md-3"} data={taxStatus} valueField={"EnumValue"} textField={"EnumName"} />
            <div className="col-md-3"></div>
            <CheckEditor label={"Internal Employee"} value={portfolio.InternalEmployee} setValue={(value) => { updatePortfolio(value, 'InternalEmployee') }} colSpan={"col-md-3"} />
        </div>
        <div className="row mb-4">
            <DropDownEditor label={"Default Cash Account"} value={{ AssetId: portfolio.DefaultCashId, AssetName: portfolio.DefaultCashAccountName }} setValue={(value) => { updatePortfolioByDD(value?.AssetId, value?.AssetName, 'DefaultCashId', "DefaultCashAccountName") }} colSpan={"col-md-3"} data={cash} valueField={"AssetId"} textField={"AssetName"} />
            <DropDownEditor label={"Default Expense Account"} value={{ AssetId: portfolio.DefaultExpenseId, AssetName: portfolio.DefaultExpenseAccountName }} setValue={(value) => { updatePortfolioByDD(value?.AssetId, value?.AssetName, 'DefaultExpenseId', "DefaultExpenseAccountName") }} colSpan={"col-md-3"} data={expense} valueField={"AssetId"} textField={"AssetName"} />
            <DropDownEditor label={"Credit Facility Account"} value={{ AssetId: portfolio.CreditFacilityAccountId, AssetName: portfolio.DefaultCreditFacilityAccountName }} setValue={(value) => { updatePortfolioByDD(value?.AssetId, value?.AssetName, 'CreditFacilityAccountId', "DefaultCreditFacilityAccountName") }} colSpan={"col-md-3"} data={creditFacility} valueField={"AssetId"} textField={"AssetName"} />
            {/* <CheckEditor label={"Billing Exclusion"} value={portfolio.BillingExclusion} setValue={(value) => { updatePortfolio(value, 'BillingExclusion') }} colSpan={"col-md-3"} /> */}
            <CheckEditor label={"Partnership"} value={portfolio.IsPartnership} setValue={(value) => { updatePortfolio(value, 'IsPartnership') }} colSpan={"col-md-3"} />

        </div>
        <div className="row mb-4">
            <div className={"col-md-3"}>
                <span className="d-block">
                    {"Notes"}
                </span>
                <textarea className="form-control" onChange={(e) => { updatePortfolio(e?.target?.value || '', 'Notes') }} defaultValue={portfolio.Notes || ''} />
            </div>
            <div className="col-md-3"></div>
            <div className="col-md-3"></div>
            <CheckEditor label={"Charitable Status"} value={portfolio.CharitableStatus} setValue={(value) => { updatePortfolio(value, 'CharitableStatus') }} colSpan={"col-md-3"} />
        </div>
        <PortfolioInvestmentSection operation={operation} portfolioId={portfolio.PortfolioId} setMovedInvestment={setMovedInvestment} />
        <div className="d-flex ">
            <button className="s-sm-btn mx-1" onClick={() => { setDrawer(false) }} >Cancel</button>
            <button className="p-sm-btn mx-1" onClick={() => { insertOrUpdatePortfolio() }} disabled={!isEdit}> {operation}</button>
        </div>
    </>
};
const PortfolioInvestmentSection = ({ portfolioId, setMovedInvestment, operation }) => {
    const [existingInvestemnt, setExistingInvestment] = useState([]);
    const [availableInvestemnt, setAvailableInvestment] = useState([]);
    const availableRef = useRef();
    const existingRef = useRef();
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable]);

    const availableInvestDef = [{ field: "AssetName", headerName: "Asset Name", flex: 1, filter: "agTextColumnFilter", floatingFilter: true },
    { field: "ChartOfAccount", headerName: "Chart Of Account", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true }];
    const existingInvestDef = [{ field: "AssetName", headerName: "Asset Name", flex: 1, filter: "agTextColumnFilter", floatingFilter: true },
    { field: "AccountingMode", headerName: "Accounting Mode", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true },
    { field: "ChartOfAccount", headerName: "Chart Of Account", flex: 0.5, filter: "agTextColumnFilter", floatingFilter: true }];
    useEffect(() => {
        getInvestmentData();
    }, [portfolioId])
    const getInvestmentData = () => {
        if (portfolioId || portfolioId == 0) {
            sbaAxios({ url: getPortfolioAvailableAsset + portfolioId }).then(res => {
                setAvailableInvestment(res)
            }).catch(error => {
                setAvailableInvestment([]);
                console.log("Error loading the Available Asset API");
            });
            if (portfolioId !== 0)
                sbaAxios({ url: getPortfolioExistingAsset + portfolioId }).then(res => {
                    setExistingInvestment(res)
                }).catch(error => {
                    setAvailableInvestment([]);
                    console.log("Error loading the Existing Asset API");
                });
        }
    };
    const addInvestment = () => {
        const selectedRow = availableRef.current.api.getSelectedRows()[0];
        const isexistingRow = existingInvestemnt.find(item => item?.AssetId == selectedRow?.AssetId);
        if (selectedRow && !isexistingRow) {
            const data = {
                "portfolioId": portfolioId,
                "assetId": selectedRow.AssetId,
                "modifiedBy": 0
            };
            if (operation === "Update") {
                sbaAxios({ url: insertPorfolioAccountingAssetAPI, method: "post", data: data }).then(res => {
                    setExistingInvestment(value => ([selectedRow, ...value]));
                    setAvailableInvestment(value => (value.filter(item => item.AssetId !== selectedRow.AssetId)));
                    SBNotify({ Msg: 'Selected Accounting Asset Has Been Added Successfully' })
                }).catch(e => {
                    console.log(e, 'Error inserting Accounting Asset')
                })
            }
            else if (operation === "Add") {
                setAvailableInvestment(value => (value.filter(item => item.AssetId !== selectedRow.AssetId)));
                setExistingInvestment(value => ([selectedRow, ...value]));
                setMovedInvestment(value => ([selectedRow, ...value]));
            };
        }
    }
    return <div className="row mb-4">
        <div className="col-md-5">
            <span >Available Investment </span>
            <div className="ag-theme-alpine" style={{ height: '500px' }}>
                <AgGridReact
                    columnDefs={availableInvestDef}
                    rowData={availableInvestemnt}
                    defaultColDef={{resizable:true}}
                    pagination={true}
                    paginationPageSize={10}
                    ref={availableRef}
                    rowSelection="single"
                >
                </AgGridReact></div>
        </div>
        <div className="col-md-1 d-flex justify-content-center align-items-center m-4">
            <button className="p-sm-btn" onClick={addInvestment} disabled={!isEdit}>Add</button>
        </div>
        <div className="col-md-5">
            <span >Existing Investment </span>
            <div className="ag-theme-alpine" style={{ height: '500px' }}>
                <AgGridReact
                    columnDefs={existingInvestDef}
                    rowData={existingInvestemnt}
                    defaulfColDef={{ filter: "agTextColumnFilter" ,resizable:true}}
                    pagination={true}
                    paginationPageSize={10}
                    ref={existingRef}
                >
                </AgGridReact></div>
        </div>
    </div>
};
const TextEditor = ({ type, value, setValue, colSpan, mandatory, label }) => {
    return <>
        <div className={colSpan + " mb-2"}>
            <span>
                {label}
                {mandatory && <span class="mandatory">*</span>}
            </span>
            <div >
                <input
                    className="form-control w-75"
                    value={value}
                    type={type}
                    onChange={(e) => { setValue(e.target.value) }}
                />
            </div>
        </div>
    </>
};
const DropDownEditor = ({ label, value, setValue, colSpan, mandatory, data, valueField, textField, ...props }) => {
    return <>
        <div className={colSpan + " mb-2"}>
            <span>
                {label}
                {mandatory && <span class="mandatory">*</span>}
            </span>
            <div >
                <SBAComboBox
                    data={data}
                    textField={textField}
                    valueField={valueField}
                    popupSettings={{ className: 'modalDD' }}
                    className="w-75"
                    value={value}
                    onChange={(e) => { setValue(e.value) }}
                    {...props}
                />
            </div>
        </div>
    </>
};
const CheckEditor = ({ value, setValue, colSpan, mandatory, label }) => {
    return <>
        <div className={colSpan + " row-items mb-2"}>
            <span >
                <input
                    className="me-2"
                    checked={value}
                    type={"checkbox"}
                    onChange={(e) => { setValue(e.target.checked) }}
                />
                {label}
                {mandatory && <span class="mandatory">*</span>}
            </span>
        </div>
    </>
};

